export interface ItemsCount {
    key: string;
    value: number;
}
